import { Box, BoxProps, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';

import { FacebookIcon, LinkedinIcon, XIcon } from '../../components/icons';

function ShareButtons({
  url,
  title,
  summary,
  themes,
  ...props
}: { summary?: string; themes?: string[]; title: string; url: string } & BoxProps) {
  const { t } = useTranslation();

  return (
    <Box alignItems="center" display="flex" gap={1} {...props}>
      <Typography color="primary" fontSize="1.125rem">
        {t('commons.actions.share')} :
      </Typography>
      <LinkedinShareButton style={{ height: 24 }} summary={summary} title={title} url={url}>
        <LinkedinIcon color="action" />
      </LinkedinShareButton>
      <TwitterShareButton
        hashtags={themes}
        style={{ height: 24 }}
        title={title}
        url={url}
        via="geovelofr"
      >
        <XIcon color="action" />
      </TwitterShareButton>
      <FacebookShareButton style={{ height: 24 }} url={url}>
        <FacebookIcon color="action" />
      </FacebookShareButton>
    </Box>
  );
}

export default ShareButtons;
